:host {
  --color: var(--stzh-tag-color, #{$colorSecondary60});
  --height: 24px;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-left: #{space("small")};
  --padding-right: #{space("small")};
  --background-color: var(--stzh-tag-background-color, #{$colorGrey20});

  --hover-color: var(--stzh-tag-hover-color, #{$colorSecondary60});
  --hover-background-color: var(
    --stzh-tag-hover-background-color,
    var(--background-color)
  );

  display: inline-flex;

  &[size="large"] {
    --height: 32px;
  }

  &[size="default"][type="secondary"] {
    --background-color: var(
      --stzh-tag-secondary-background-color,
      #{$colorSecondary60}
    );
  }

  &[type="secondary"] {
    --color: var(--stzh-tag-secondary-color, #{$colorWhite});
    --background-color: var(
      --stzh-tag-secondary-background-color,
      #{$colorSecondary60}
    );
    --hover-color: var(--stzh-tag-secondary-hover-color, #{$colorWhite});
    --hover-background-color: var(
      --stzh-tag-secondary-hover-background-color,
      var(--background-color)
    );
  }

  &[non-interactive]:not([non-interactive="false"]) {
    --hover-color: var(--color);
    --hover-background-color: var(--background-color);
  }

  &[disabled]:not([disabled="false"]) {
    --color: var(--stzh-tag-disabled-color, #{$colorGrey70});
    --background-color: var(
      --stzh-tag-disabled-background-color,
      #{$colorGrey20}
    );

    --hover-color: var(--color);
    --hover-background-color: var(--background-color);
  }
}

.stzh-tag {
  position: relative;

  &__button {
    @include fontSize("nano");
    font-family: inherit;
    height: var(--height);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);
    padding-left: var(--padding-left);
    padding-right: var(--padding-right);
    color: var(--color);
    appearance: none;
    border: none;
    background-color: var(--background-color);
    transition-duration: $baseTransitionAnimationSpeed;
    transition-property: color, background-color;
    text-decoration-line: none;

    &.is-button,
    &.is-link {
      cursor: pointer;
    }
  }

  &__label {
    text-align: left;
  }

  &__button:hover {
    color: var(--hover-color);
    background-color: var(--hover-background-color);
  }

  /* Size */

  &--size-large &__button {
    @include font("heavy");
    @include fontSize("milli");
  }

  /* Disabled */

  &--is-disabled &__button {
    cursor: not-allowed;
  }
}
